module.exports = __webpack_public_path__ + "img/map_1791452207124_7100.e21a0719.gif";